import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';

import MapView from './MapView';
import BookmarkButton from './BookmarkButton';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class GreinView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/greinar/';

		this.state = {
			loading: false
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		let params = [];

		this.setState({
			loading: true
		});

		fetch(this.url+this.props.match.params.id+'/')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					mapData: json.baeir.length > 0 ? json.baeir.map(item => {
						return {
							id: item.id,
							label: item.baejarnafn,
							district: (item.hreppur ? item.hreppur.nafn+', ' : '')+item.sysla.nafn,
							type: 'farm',
							tegund: item.tegund ? item.tegund : null,
							latLng: [item.lat, item.lng]
						}
					}) : [],
					loading: false

				});
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className={'column-content'+(this.state.loading ? ' loading' : '')}>
						{
							item &&
							<React.Fragment>

								<BreadCrumbs path={[
									{
										path: '/greinar/',
										title: 'Greinar'
									},
									{
										path: item.id,
										title: item.title
									}
								]} />

								<h3>{item.title}</h3>
								<hr/>


								<div className="row">
									<div className="col col-6">
	
										<div dangerouslySetInnerHTML={{__html: item.content}} />

										{
											item.article_collection && <React.Fragment>
												<p class="mb-2">
													<strong>Greinasafn:</strong> <Link class="badge badge-light" to={'/greinar/'+item.article_collection.id}>{item.article_collection.name}</Link>
												</p>
												<hr/>
											</React.Fragment>
										}

										{
											item.authors.length > 0 && <React.Fragment>
												<h5>{item.authors.length > 1 ? 'Höfundar' : 'Höfundur'}</h5>

												<table className="table">
													<tbody>
														{
															item.authors.map((item, index) => <tr key={index}><td><Link to={'/einstaklingur/'+item.id}>{item.nafn}</Link></td></tr>)
														}
													</tbody>
												</table>
											</React.Fragment>
										}

									</div>

									<div className="col col-6">

										{
											item.baeir.length > 0 && <React.Fragment>
												<h5>Tengdir bæir</h5>

												<table className="table">
													<tbody>
														{
															item.baeir.map((item, index) => <tr key={index}><td><Link to={'/baer/'+item.id}>{item.baejarnafn}</Link>, {(item.sveitarfelag && item.hreppur ? item.sveitarfelag.nafn+' ('+item.hreppur.nafn+'), ' : '')}{item.sysla.nafn.replace(/(.*?)a$/,'$1u')})</td></tr>)
														}
													</tbody>
												</table>
											</React.Fragment>
										}

										{
											this.state.mapData && this.state.mapData.length > 0 &&
											<MapView mapData={
													this.state.mapData
												}
											/>
										}

									</div>

								</div>

							</React.Fragment>
						}
					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(GreinView);



// WEBPACK FOOTER //
// ./src/components/GreinView.js